import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';
import API_BASE_URL from '../../Config';

const BalanceSaldos = () => {
    const [balanceData, setBalanceData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [fechaFin, setFechaFin] = useState(format(new Date(), 'yyyy-MM-dd'));

    const fetchBalance = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`${API_BASE_URL}/contabilidad/balance?fin=${fechaFin}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setBalanceData(res.data);
        } catch (error) {
            console.error("Error cargando el balance de sumas y saldos", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBalance();
    }, []);

    return (
        <div className="card shadow-sm border-0">
            <div className="card-header bg-white border-bottom-0 pt-4 pb-2 d-flex justify-content-between align-items-center">
                <h3 className="mb-0 text-gray-800 font-weight-bold">Balance de Sumas y Saldos</h3>
                <div className="d-flex align-items-center gap-2">
                    <div className="input-group input-group-sm shadow-sm" style={{ width: '220px' }}>
                        <div className="input-group-prepend">
                            <span className="input-group-text bg-white"><i className="fas fa-calendar-alt text-primary"></i></span>
                        </div>
                        <input 
                            type="date" 
                            value={fechaFin} 
                            onChange={e => setFechaFin(e.target.value)} 
                            className="form-control" 
                        />
                    </div>
                    <button className="btn btn-primary btn-sm px-3 shadow-sm" onClick={fetchBalance} disabled={loading}>
                        <i className="fas fa-sync-alt mr-2"></i> Procesar
                    </button>
                </div>
            </div>
            
            <div className="card-body p-0 mt-3">
                {loading ? (
                    <div className="text-center p-5">
                        <div className="spinner-border text-primary" role="status"></div>
                        <p className="mt-3 text-muted">Consolidando saldos contables...</p>
                    </div>
                ) : balanceData ? (
                    <div className="table-responsive mdi-scrollbar" style={{ maxHeight: '70vh' }}>
                        <table className="table table-sm table-bordered table-hover mb-0" style={{ fontSize: '0.85rem' }}>
                            <thead className="thead-light sticky-top shadow-sm">
                                <tr>
                                    <th rowSpan="2" className="align-middle text-center border-bottom-0 bg-light py-3">CÓDIGO</th>
                                    <th rowSpan="2" className="align-middle border-bottom-0 bg-light py-3 px-3">CUENTA CONTABLE</th>
                                    <th colSpan="2" className="text-center bg-gray-100 py-1" style={{ backgroundColor: '#f3f4f6' }}>SUMAS DEL PERIODO</th>
                                    <th colSpan="2" className="text-center bg-gray-200 py-1" style={{ backgroundColor: '#e5e7eb' }}>SALDOS ACTUALES</th>
                                </tr>
                                <tr>
                                    <th className="text-right py-2 px-3 border-top-0 bg-light">DEBE</th>
                                    <th className="text-right py-2 px-3 border-top-0 bg-light">HABER</th>
                                    <th className="text-right py-2 px-3 border-top-0 bg-light">DEUDOR</th>
                                    <th className="text-right py-2 px-3 border-top-0 bg-light">ACREEDOR</th>
                                </tr>
                            </thead>
                            <tbody>
                                {balanceData.filas.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" className="text-center py-5">
                                            <i className="text-muted">No se encontraron movimientos registrados hasta la fecha.</i>
                                        </td>
                                    </tr>
                                ) : (
                                    balanceData.filas.map((fila, idx) => (
                                        <tr key={idx} className={fila.nivel === 'TITULO' ? 'bg-light font-weight-bold text-dark' : 'text-secondary'}>
                                            <td className="text-center font-mono py-1" style={{ fontSize: '0.8rem' }}>{fila.codigoCuenta}</td>
                                            <td className="px-3 py-1">{fila.nombreCuenta}</td>
                                            <td className="text-right px-3 py-1 font-mono">{fila.debe > 0 ? new Intl.NumberFormat('es-PY').format(fila.debe) : '-'}</td>
                                            <td className="text-right px-3 py-1 font-mono">{fila.haber > 0 ? new Intl.NumberFormat('es-PY').format(fila.haber) : '-'}</td>
                                            <td className="text-right px-3 py-1 font-mono text-blue-800 font-weight-bold">{fila.saldoDeudor > 0 ? new Intl.NumberFormat('es-PY').format(fila.saldoDeudor) : '-'}</td>
                                            <td className="text-right px-3 py-1 font-mono text-green-800 font-weight-bold">{fila.saldoAcreedor > 0 ? new Intl.NumberFormat('es-PY').format(fila.saldoAcreedor) : '-'}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                            <tfoot className="bg-dark text-white shadow-sm font-weight-bold sticky-bottom" style={{ position: 'sticky', bottom: 0, zIndex: 5 }}>
                                <tr>
                                    <td colSpan="2" className="text-right py-2 px-3" style={{ fontSize: '0.9rem' }}>TOTALES DE CONTROL:</td>
                                    <td className="text-right py-2 px-3 font-mono">{new Intl.NumberFormat('es-PY').format(balanceData.totalDebe)}</td>
                                    <td className="text-right py-2 px-3 font-mono">{new Intl.NumberFormat('es-PY').format(balanceData.totalHaber)}</td>
                                    <td className="text-right py-2 px-3 font-mono" style={{ color: '#93c5fd' }}>{new Intl.NumberFormat('es-PY').format(balanceData.totalSaldoDeudor)}</td>
                                    <td className="text-right py-2 px-3 font-mono" style={{ color: '#86efac' }}>{new Intl.NumberFormat('es-PY').format(balanceData.totalSaldoAcreedor)}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                ) : (
                    <div className="text-center p-5 text-muted">No se pudo recuperar la información del balance.</div>
                )}
            </div>
        </div>
    );
};

export default BalanceSaldos;
